import React from 'react'

import {
  Box,
  Space,
  Text,
  Display,
  FontFamily,
  FontWeight,
  FlexDirection,
  AlignItems,
} from '@gousto-internal/citrus-react'

import { formatPrice } from 'utils/format'

import { CTAHomepageContainer } from '../CTA'
import { SectionTitle } from '../SectionTitle'
import { useGetCtaProps, useGetPricePerServing } from '../homeHooks'
import { StepsGuide } from './StepsGuide'
import { SECTION_TITLE } from './data'

export const WhyChooseGoustoSubtitle = () => {
  const pricePerServing = useGetPricePerServing()

  return (
    <>
      Impressively easy meals from just{' '}
      <Text display={Display.Inline} fontFamily={FontFamily.Bold} data-testid="price-per-serving">
        {pricePerServing ? formatPrice(pricePerServing) : ''} per serving
      </Text>
      <Text display={Display.Inline} fontWeight={FontWeight.SemiBold}>
        <sup>†</sup>
      </Text>
      . All of the flavour, none of the fuss.
    </>
  )
}

export const WhyChooseGousto = () => {
  const { ctaUri, ctaText } = useGetCtaProps()

  return (
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      data-testid="WhyChooseGousto"
      alignItems={AlignItems.Center}
      paddingV={[12, 10]}
      paddingH={[3, 8]}
      paddingBottom={[10, 6]}
    >
      <SectionTitle title={SECTION_TITLE} subTitle={<WhyChooseGoustoSubtitle />} />
      <StepsGuide />
      <Space direction="vertical" size={[0, 8]} />
      <Box display={[Display.None, Display.Block]} width="17.5rem">
        <CTAHomepageContainer ctaUri={ctaUri} sectionForTracking="whyChooseGousto">
          {ctaText}
        </CTAHomepageContainer>
      </Box>
    </Box>
  )
}
